import React from 'react';

import '../../styles/Heading.css';

const Heading = ({emoji, title, subtitle}) => (
  <div class="heading-wrapper">
    {emoji && <img class="emoji" src={emoji} alt={title}/>}
    <h2 class="heading-title">{title}</h2>
    <h5 class="heading-subtitle">{subtitle}</h5>
  </div>
)

export default Heading;